import { useLocation, useNavigate } from 'react-router-dom';
import { Layout, Menu } from 'antd';
import {
  BellOutlined,
  DashboardOutlined,
  SettingOutlined,
  BarChartOutlined,
  DoubleRightOutlined,
  DoubleLeftOutlined,
  ShopOutlined,
  UserOutlined,
  ToolOutlined,
} from '@ant-design/icons';
import { usePermissions } from '../../hooks/usePermissions';
import journiyIcon from '../../../../src/images/icon-01.png';
import journiyLogo from '../../../../src/images/logo-01.png';

const { Sider } = Layout;

const items = [
  { key: '/', icon: <DashboardOutlined />, label: 'Dashboard' },
  { key: '/bi', icon: <BarChartOutlined />, label: 'Business Intelligence' },
];

const settingsItem = { key: '/settings', icon: <SettingOutlined />, label: 'Settings' };

/**
 * Navigation sidebar. The active item is derived from the current
 * location so deep links (e.g. /contacts) highlight correctly.
 */
export default function Sidebar({ collapsed, onToggle }) {
  const location = useLocation();
  const navigate = useNavigate();
  const { can } = usePermissions();

  const dataItems = [
    ...(can('viewUsers')
      ? [{ key: '/users', icon: <UserOutlined />, label: 'Users' }]
      : []),
    ...(can('viewRestaurants')
      ? [{ key: '/restaurants', icon: <ShopOutlined />, label: 'Restaurants' }]
      : []),
    ...(can('viewNotifications')
      ? [{ key: '/notifications', icon: <BellOutlined />, label: 'Notifications' }]
      : []),
    ...(can('storageHygiene') || can('onboarding') || can('imageSyncTool')
      ? [{ key: '/tools', icon: <ToolOutlined />, label: 'Tools' }]
      : []),
  ];
  const menuItems = [...items, ...dataItems];

  const selectedKeys = menuItems
    .map((i) => i.key)
    .filter((key) =>
      key === '/' ? location.pathname === '/' : location.pathname.startsWith(key),
    );

  return (
    <Sider
      className="admin-sidebar"
      collapsible
      collapsed={collapsed}
      collapsedWidth={64}
      width={220}
      trigger={null}
      theme="light"
    >
      <div className="admin-logo" title="Journiy Admin" aria-label="Journiy Admin">
        <img
          className={collapsed ? 'admin-logo-image admin-logo-icon' : 'admin-logo-image admin-logo-wordmark'}
          src={collapsed ? journiyIcon : journiyLogo}
          alt="Journiy"
        />
      </div>
      <Menu
        className="admin-nav"
        theme="light"
        mode="inline"
        selectedKeys={selectedKeys}
        items={menuItems}
        onClick={({ key }) => navigate(key)}
      />
      <div className="admin-sidebar-bottom">
        <Menu
          className="admin-nav"
          theme="light"
          mode="inline"
          selectedKeys={selectedKeys}
          items={[settingsItem]}
          onClick={({ key }) => navigate(key)}
        />
        <button
          className="admin-sidebar-toggle"
          type="button"
          onClick={onToggle}
          title={collapsed ? 'Expand navigation' : 'Collapse navigation'}
        >
          {collapsed ? <DoubleRightOutlined /> : <DoubleLeftOutlined />}
        </button>
      </div>
    </Sider>
  );
}
